export const adjustScrollAfterImages = (
    el: HTMLElement,
    scrollAction: (el: HTMLElement) => void
): void => {
    const pendingImages = Array.from(
        el.querySelectorAll<HTMLImageElement>('img[data-sms-attachment]')
    ).filter((image) => !image.complete);

    if (!pendingImages.length) {
        return;
    }

    let remaining = pendingImages.length;

    const onImageDone = () => {
        remaining -= 1;

        if (remaining > 0) {
            return;
        }

        requestAnimationFrame(() => {
            scrollAction(el);
        });
    };

    pendingImages.forEach((image) => {
        image.addEventListener('load', onImageDone, { once: true });
        image.addEventListener('error', onImageDone, { once: true });
    });
};
